(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9534,682],{

/***/ 9534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Carousel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2873);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8116);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9846);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _carousel_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3634);
/* harmony import */ var _carousel_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_carousel_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var src_helpers_imageHelpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(682);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5893);














function Carousel(_ref) {
  var footerLinks = _ref.footerLinks,
      _ref$posts = _ref.posts,
      posts = _ref$posts === void 0 ? [] : _ref$posts;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var lang = router.locale;
  var dir = lang === "ar" ? "rtl" : "ltr";

  var normalizeSettingValue = function normalizeSettingValue(value) {
    return typeof value === "string" ? value.replace(/`/g, "").trim() : "";
  };

  var isRtl = lang === "ar";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
    className: (_carousel_module_scss__WEBPACK_IMPORTED_MODULE_11___default().wrapper),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .t, {
      modules: [swiper__WEBPACK_IMPORTED_MODULE_5__/* .Pagination */ .tl, swiper__WEBPACK_IMPORTED_MODULE_5__/* .Autoplay */ .pt, swiper__WEBPACK_IMPORTED_MODULE_5__/* .EffectFade */ .xW],
      pagination: {
        clickable: true
      },
      effect: "fade",
      slidesPerView: 1,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
      dir: dir,
      children: posts === null || posts === void 0 ? void 0 : posts.map(function (post, index) {
        var _post$data, _post$data$ctaText, _post$data2, _post$data2$ctaText, _post$data3, _post$data3$ctaText, _post$data4, _post$data5, _post$data6, _post$data6$title, _post$data7, _post$data7$descripti;

        var ctaText = normalizeSettingValue(post === null || post === void 0 ? void 0 : (_post$data = post.data) === null || _post$data === void 0 ? void 0 : (_post$data$ctaText = _post$data.ctaText) === null || _post$data$ctaText === void 0 ? void 0 : _post$data$ctaText[lang]) || normalizeSettingValue(post === null || post === void 0 ? void 0 : (_post$data2 = post.data) === null || _post$data2 === void 0 ? void 0 : (_post$data2$ctaText = _post$data2.ctaText) === null || _post$data2$ctaText === void 0 ? void 0 : _post$data2$ctaText.ar) || normalizeSettingValue(post === null || post === void 0 ? void 0 : (_post$data3 = post.data) === null || _post$data3 === void 0 ? void 0 : (_post$data3$ctaText = _post$data3.ctaText) === null || _post$data3$ctaText === void 0 ? void 0 : _post$data3$ctaText.en);
        var ctaUrl = normalizeSettingValue(post === null || post === void 0 ? void 0 : (_post$data4 = post.data) === null || _post$data4 === void 0 ? void 0 : _post$data4.ctaUrl);
        var isExternalCtaUrl = /^https?:\/\//i.test(ctaUrl);
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
            className: "overlay"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: (0,src_helpers_imageHelpers__WEBPACK_IMPORTED_MODULE_9__/* .buildApiUrl */ .f8)(post === null || post === void 0 ? void 0 : (_post$data5 = post.data) === null || _post$data5 === void 0 ? void 0 : _post$data5.image),
            alt: "slider-".concat(index),
            priority: index === 0,
            loading: index === 0 ? "eager" : "lazy",
            sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 100vw",
            width: 1900,
            height: 1000,
            quality: index === 0 ? 85 : 75
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__["default"], {
            className: "h-100",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
              className: "text",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("h2", {
                children: post === null || post === void 0 ? void 0 : (_post$data6 = post.data) === null || _post$data6 === void 0 ? void 0 : (_post$data6$title = _post$data6.title) === null || _post$data6$title === void 0 ? void 0 : _post$data6$title[lang]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
                children: post === null || post === void 0 ? void 0 : (_post$data7 = post.data) === null || _post$data7 === void 0 ? void 0 : (_post$data7$descripti = _post$data7.description) === null || _post$data7$descripti === void 0 ? void 0 : _post$data7$descripti[lang]
              }), ctaText && ctaUrl ? isExternalCtaUrl ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("a", {
                href: ctaUrl,
                target: "_blank",
                rel: "noreferrer",
                className: (_carousel_module_scss__WEBPACK_IMPORTED_MODULE_11___default().ctaLink),
                children: [ctaText, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                  className: (_carousel_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["icon-circle"]),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("svg", {
                    style: {
                      transform: isRtl ? "none" : "scaleX(-1)"
                    },
                    width: "18",
                    height: "18",
                    viewBox: "0 0 18 18",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("path", {
                      d: "M3.53577 3.53556L14.1424 14.1422",
                      stroke: "black",
                      strokeWidth: 1.5,
                      strokeLinecap: "round",
                      strokeLinejoin: "round"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("path", {
                      d: "M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553",
                      stroke: "black",
                      strokeWidth: 1.5,
                      strokeLinecap: "round",
                      strokeLinejoin: "round"
                    })]
                  })
                })]
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: ctaUrl,
                legacyBehavior: true,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("a", {
                  className: (_carousel_module_scss__WEBPACK_IMPORTED_MODULE_11___default().ctaLink),
                  children: [ctaText, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                    className: (_carousel_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["icon-circle"]),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("svg", {
                      style: {
                        transform: isRtl ? "none" : "scaleX(-1)"
                      },
                      width: "18",
                      height: "18",
                      viewBox: "0 0 18 18",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("path", {
                        d: "M3.53577 3.53556L14.1424 14.1422",
                        stroke: "black",
                        strokeWidth: 1.5,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("path", {
                        d: "M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553",
                        stroke: "black",
                        strokeWidth: 1.5,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                      })]
                    })
                  })]
                })
              }) : null]
            })
          })]
        }, index);
      })
    }, dir)
  });
}

/***/ }),

/***/ 3634:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"carousel_wrapper__KUX2N","ctaLink":"carousel_ctaLink__DrIsy","icon-circle":"carousel_icon-circle__HS4dn"};

/***/ }),

/***/ 9846:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ __webpack_exports__["default"] = (Container);

/***/ })

}]);